import type { SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useQueryState } from "@/hooks"
import type { TUser } from "@/types"
import { UserSelect } from "../forms"
import { icons } from "../utils"

const queryName = "user"

export interface IUserSearchProps extends SelectProps {
  users?: TUser[]
}

export function UserSearch({ users, ...props }: IUserSearchProps) {
  const { t } = useTranslation()
  const [value, setValue] = useQueryState<string>(queryName)

  return (
    <UserSelect
      users={users}
      placeholder={t("Search users")}
      leftSection={<icons.Search size={14} />}
      {...props}
      value={value || null}
      onChange={(value) => setValue(value as any)}
    />
  )
}

UserSearch.useValue = () => {
  const [value] = useQueryState<string>(queryName)
  return value || ""
}
